type Routes = 'behavior' | 'relationship' | 'safeDriving' | 'predictive' | 'esg' | 'financialHealth' | 'connectionEngagement' 
    | 'operationalDiscipline';

export const RouteMap = new Map<Routes, string>([
    [ 'behavior', 'behavior'],
    ['relationship', 'relationship'],
    ['safeDriving', 'safe-driving'],
    ['predictive', 'predictive'],
    ['esg', 'sustainable'],
    ['financialHealth', 'financial-health'],
    ['connectionEngagement', 'connection-engagement'],
    ['operationalDiscipline', 'operational-discipline']
]);